import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["aria-label", "colorScheme", "theme", "className", "size"];
import React from 'react';
import makeClass from 'clsx';
import { useTheme } from '@design-systems/theme';
import styles from './Dots.css';
export const sizes = ['small', 'large'];
/** A progress indicator rendered as dots */
const Dots = function (_ref) {
  let ariaLabel = _ref['aria-label'],
    colorScheme = _ref.colorScheme,
    theme = _ref.theme,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    html = _objectWithoutProperties(_ref, _excluded);
  const _useTheme = useTheme({
      theme,
      colorScheme
    }, styles),
    themeClass = _useTheme.themeClass;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: makeClass(styles.wrapper, themeClass, className, {
      [styles.large]: size === 'large'
    }),
    "aria-label": ariaLabel || 'Loading'
  }, html), /*#__PURE__*/React.createElement("div", {
    className: makeClass(styles.spinner, {
      [styles.large]: size === 'large'
    })
  }));
};
export default Dots;
//# sourceMappingURL=Dots.js.map